// The English words, one module per area of the app (R10-Q16). The source of every key.

import { admin } from "./admin";
import { auto } from "./auto";
import { chat } from "./chat";
import { common } from "./common";
import { inbox } from "./inbox";
import { me } from "./me";
import { mem } from "./mem";
import { msg } from "./msg";
import { shell } from "./shell";

export const en = { common, shell, chat, msg, inbox, auto, admin, mem, me };

/** Every area's keys; a language other than English must give each one a string. */
export type Dict = { [A in keyof typeof en]: { [K in keyof (typeof en)[A]]: string } };
